module.exports = __webpack_public_path__ + "img/letter-o.11d1c5f6.gif";